<template>
    <div>
        <config-main-title>
            Procedimentos
        </config-main-title>

        <div class="form-row mb-3">
            <div class="col col-12 col-md-3">
                <az-input icon="fas fa-search" v-model="search" @input="buscar()" placeholder="Pesquisar...">
                    <template v-slot:buttonposb>
                        <importacao service="procedimentos" @refresh="load()" :parms="{ pep: true }" />
                        <div class="input-group-append" id="button-addon4">
                            <button type="button" class="btn btn-outline-primary" @click="incluir ()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-3">
                <az-input 
                    placeholder="Todos os Grupo..." 
                    type="select"
                    icon="fa fa-filter"
                    optionsData="id_procedimento_grupo"
                    service="procedimento_grupos.index"
                    optionsMode="aql"
                    v-model="id_procedimento_grupo"
                    @input="buscar()">
                </az-input>
            </div>
            <div class="col col-12 col-md-3" v-if="$store.state.user.medico">
                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="fas fa-user-md fa-fw"></i>
                        </span>
                    </div>
                    <label class="form form-control" disabled>{{ $store.state.user.medico.search }}</label>
                </div>
            </div>
            <div class="col col-12 col-md-3" v-else>
                <az-input 
                    placeholder="Geral"
                    icon="fas fa-user-md fa-fw" 
                    type="select" 
                    optionsMode="aql"
                    service="medicos.index"
                    optionsName="medicos-cadastro"
                    :optionsParm="{ ativos: true }"
                    optionsData="id_pessoa"
                    v-model="id_medico" 
                    @change.native="load()" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'A'; load();">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'; load();">
                        Todos
                    </button>
                </div>
            </div>
        </div>

        <template v-if="!dados || !dados.data || !dados.data.length">
            <az-empty-state msg="Nenhum documento criado." />
        </template>

        <ul class="list-group" v-else>
            <li class="list-group-item" v-if="dados.last_page > 1">
                <nav>
                    <paginate
                        class="mb-0"
                        :page-count="dados.last_page"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </nav>
            </li>
            <template v-for="(medicamento, imedicamento) in dados.data">
                <li class="list-group-item d-flex justify-content-between" :key="imedicamento" v-if="viewMode == 'T' || medicamento.fl_ativo">
                    <template v-if="( $store.state.user.medico && medicamento.id_medico == $store.state.user.id_pessoa ) || 
                        ( !$store.state.user.medico )">
                        <div>
                            <a href="#" @click.prevent="editar(medicamento)" class="card-link">
                                {{ medicamento.search }}
                            </a>
                            <span v-if="medicamento.apresentacao" class="text-muted ml-3">{{ medicamento.apresentacao.search }}</span>
                            <small v-if="medicamento.st_posologia" class="text-muted ml-3">{{ medicamento.st_posologia }}</small>
                        </div>
                        <div class="text-right">
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + imedicamento" 
                                    v-model="medicamento.fl_ativo" 
                                    @change="toggle(medicamento)">
                                <label class="custom-control-label" :for="'ativo-' + imedicamento"></label>
                            </div>
                            <div v-else class="h5 mb-0">
                                <span class="badge badge-secondary" v-if="medicamento.grupo" >
                                    {{ medicamento.grupo.st_sigla }}
                                </span>
                                <span v-if="medicamento.id_especialidade && medicamento.unidade_procedimento" 
                                    class="ml-3" 
                                    :class="medicamento.unidade_procedimento.fl_ativo ? 'text-primary' : 'text-muted'"
                                    :title="'Procedimento vinculado ao faturamento' 
                                        + ( medicamento.unidade_procedimento.fl_ativo ? ' (ativo)' : ' (inativo)' )">
                                    <i class="fas fa-file-invoice-dollar"></i>
                                </span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                            {{ medicamento.search }}
                        </div>
                        <div v-if="viewMode == 'T'">
                            {{ medicamento.fl_ativo ? 'Ativo' : 'Inativo' }} 
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary ml-3" v-if="medicamento.grupo" >
                                {{ medicamento.grupo.st_sigla }}
                            </span>

                            <span v-if="medicamento.id_especialidade" title="Procedimento vinculado ao faturamento" class="ml-3">
                                <i class="fas fa-file-invoice-dollar"></i>
                            </span>
                        </div>
                    </template>
                </li>
            </template>
        </ul>

        <!-- Modal -->
        <div class="modal fade" id="editarProcedimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Procedimento
                            <span class="badge badge-secondary mx-1" v-if="item.id_procedimento">#{{ item.id_procedimento }}</span>
                            <i class="fa fa-user-md ml-2" aria-hidden="true" v-if="item.id_medico"></i>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    label="Descrição"
                                    required 
                                    :validate="validate"
                                    :edicao="!item.id_especialidade"
                                    v-model="item.st_procedimento" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Código TUSS"
                                    :validate="validate"
                                    :edicao="!item.id_especialidade"
                                    v-model="item.st_codigo_cbhpm" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input 
                                    label="Classificação" 
                                    type="select"
                                    optionsData="id_classe_procedimento"
                                    service="classe_procedimentos.index"
                                    optionsMode="aql"
                                    v-model="item.id_classe_procedimento" 
                                    :edicao="!item.id_especialidade"
                                    required
                                    :validate="validate" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input 
                                    label="Grupo" 
                                    type="select"
                                    optionsData="id_procedimento_grupo"
                                    service="procedimento_grupos.index"
                                    optionsMode="aql"
                                    v-model="item.id_procedimento_grupo" 
                                    :validate="validate" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Texto para Impressão"
                                    type="textarea"
                                    placeholder="Descrição..."
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_texto_requisicao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_obs" />
                            </div>
                        </div>

                        <template v-if="!item.id_especialidade">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        label="Quantidade Padrão"
                                        placeholder="Padrão..."
                                        :validate="validate"
                                        v-model="item.in_qtde_default" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input 
                                        label="Procedimento de Cobrança"
                                        placeholder="Selecione o procedimento..."
                                        type="autocomplete" 
                                        service="procedimentos.index"
                                        optionsMode="aql"
                                        optionsName="procedimentos.index" 
                                        optionsData="id_procedimento"
                                        v-model="item.id_procedimento_cobranca" />
                                </div>
                            </div>
                        </template>

                        <div class="form-row mt-3">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Permitir Editar Texto no Lançamento"
                                    type="checkbox-group" 
                                    :edicao="!!item.st_texto_requisicao"
                                    v-model="item.fl_permite_editar_texto" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Não exibir quantidade na requisição"
                                    type="checkbox-group" 
                                    v-model="item.fl_esconder_qt_req" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Imprimir Separado"
                                    type="checkbox-group" 
                                    v-model="item.fl_imprimir_separado" />
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" v-if="item.id_especialidade" @click="abrir_cadastro(item)">Cadastro</button>
                        <az-audit-log-button model="procedimento" :id="item.id_procedimento" v-if="item.id_procedimento" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_procedimento ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>        

    </div>
</template>

<script>
import $ from 'jquery';
import ConfigMainTitle from '../../../cadastros/shared/ConfigMainTitle.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubmit from '../../../util/AzSubmit.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import Importacao from '../../../cadastros/shared/Importacao.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue'

export default {
    data () { 
        return { 
            dados: null, 
            item: null,
            validate: false, 
            search: "", 
            id_procedimento_grupo: "", 
            timeout: null, 
            viewMode: 'A',
            page: 1, 
            id_medico: "" 
        }
    },

    props: ['config'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzSubmit,  
        AzEmptyState,
        Importacao, 
        AzAuditLogButton, 
    },  

    watch: { 
        viewMode: function () { 
            this.load();
        }
    },
    
    methods: { 
        abrir_cadastro (item) { 
            this.$util.abrirProcedimento(item);
        },

        paginar(page) { 
            this.load(page);
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'procedimentos',
                dados: item,
            });

        },

        buscar() { 
            if (this.timeout) { 
                clearTimeout(this.timeout); 
                this.timeout = null;
            }

            this.timeout = setTimeout(() => {
                this.load ();
            }, 300);
        },

        incluir () { 
            this.validate = false; 
            
            this.editar ({ 
                id_procedimento: null, 
                id_medico: this.$store.state.user.medico ? this.$store.state.user.id_pessoa : null, 
                st_procedimento: "",
                st_obs: "",
                st_texto_requisicao: "", 
                fl_ativo: true,
                st_codigo_cbhpm: "", 
                fl_exibir_especialidade: false, 
                fl_imprimir_separado: false, 
                fl_esconder_qt_req: false, 
            });
        },

        editar (item) { 
            this.validate = false; 
            this.item = null; 

            this.$nextTick(() => {
                this.item = { ...item };
                $('#editarProcedimentoModal').modal('show');
            });
        },

        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'procedimentos',
                dados: { 
                    ...this.item,
                    cadastro_pep: true
                },
                modal: 'editarProcedimentoModal',
                reload: true, 
            })

        },

        load (page = 1) { 
            this.$util.load(this, { 
                service: 'pep_procedimentos', 
                parms: { 
                    search: this.search,
                    cadastro_pep: true,
                    size: 20, 
                    page: page,
                    mode: this.viewMode,
                    id_medico: this.id_medico,
                    id_procedimento_grupo: this.id_procedimento_grupo, 
                    cadastro: true, 
                },
            });
        }
    },

    mounted () { 
        if ( this.config ) { 

            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: "Prontuário", path: "/cadastros" },
                    { name: "Procedimentos", path: "/procedimentos" },
                ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

        }

        this.load ();
    }

}
</script>